import {Component, OnInit, ViewChild} from '@angular/core';
import {FuncionarioFormComponent} from '../funcionario-form/funcionario-form.component';
import {ModalService} from 'src/app/shared/services/modal.service';
import {DialogService, DynamicDialogRef} from 'primeng/dynamicdialog';
import {Store} from '@ngrx/store';
import {funcionarioActions} from 'src/app/store/funcionario/funcionario.actions';
import {selectFuncionarioLista, selectFuncionarioState} from 'src/app/store/funcionario/funcionario.selectors';
import {loadUnidade} from 'src/app/store/unidade/unidade.actions';
import {selectUnitActiveList} from 'src/app/store/unidade/unidade.selectors';
import {FuncionarioFilter, FuncionarioService, IFuncionarioFilter} from 'src/app/shared/services/funcionario.service';
import {ProfessionService} from 'src/app/shared/services/profession.service';
import {Filter} from 'src/app/shared/models/filter';
import {SplitTableComponent} from "../../../../shared/components/split-table/split-table.component";

@Component({
  selector: 'app-funcionario-lista',
  templateUrl: './funcionario-lista.component.html',
  styleUrls: ['./funcionario-lista.component.scss']
})
export class FuncionarioListaComponent implements OnInit {
  filter = new FuncionarioFilter();

  mostrarModalInativar: boolean = false
  mostrarModalDeletar: boolean = false
  mostrarModalAtivar: boolean = false
  isLoading: boolean = true;
  selectedItemId: number = 9999999999
  filters: Array<any> = [];
  filterParams = new Filter().filter('isActive', '1').size(10);
  selectedItem: any
  totalItems: any = null;

  employeeList$ = this.store.select(selectFuncionarioLista)
  listaUnidades$ = this.store.select(selectUnitActiveList);
  funcionarioState$ = this.store.select(selectFuncionarioState)

  ref: DynamicDialogRef | undefined;

  @ViewChild("idTable") protected tableRef!: SplitTableComponent;

  readonly ID_UNIT_FILTER = 'unit';
  readonly ID_PROFESSION_FILTER = 'profession';

  protected listActive = [
    {name: 'Ativo', id: 1}, 
    {name: 'Inativo', id: 0}
  ];

  constructor(
    public dialogService: DialogService,
    private modalService: ModalService,
    private funcionarioService: FuncionarioService,
    private professionService: ProfessionService,
    private store: Store,
  ) {
    this.funcionarioService.setFilter(new FuncionarioFilter());
  }

  ngOnInit(): void {
    this.funcionarioService.totalItems$.subscribe(total => {
      this.totalItems = total;
      this.isLoading = false;
    });

    this.load();

    this.funcionarioState$.subscribe(res => {
      console.log('employee state: ', res)
      if (res.action != 'get' && res.type == 'success') {
        this.load();
      }
    })

    this.store.dispatch(loadUnidade());

    this.loadUnitFilter();
    this.loadProfessionFilter();
  }

  load() {
    this.isLoading = true;
    this.funcionarioService.setFilterQueryParams(this.filterParams.convertFilterInQuery());
    this.store.dispatch(funcionarioActions.loadFuncionario());
  }

  loadUnitFilter() {
    this.listaUnidades$.subscribe((result: Array<any>) => {

      let exist = this.filters.find(item => item.id == this.ID_UNIT_FILTER) != undefined;

      if (result.length == 0 || exist) {
        return;
      }

      let data = result.map((item: { id: string, unitName: string }) => {
        return {value: item.unitName, code: item.id}
      });

      this.filters.push({
        id: this.ID_UNIT_FILTER,
        type: "DROPDOWN",
        name: "Unidade",
        data: data
      });
    })
  }

  loadProfessionFilter() {
    this.professionService.getAll().subscribe((result: any) => {
      if (result.length == 0) {
        return;
      }

      let data = result.map((item: { id: string, name: string }) => {
        return {value: item.name, code: item.id}
      });

      this.filters.push({
        id: this.ID_PROFESSION_FILTER,
        type: "DROPDOWN",
        name: "Profissão",
        data: data
      });
    })
  }

  cadastrarFuncionario() {
    this.modalService.calledfor('cadastrar');
    this.modalService.show(FuncionarioFormComponent, 'Cadastro do Funcionário')
  }

  editarFuncionario(funcionario: any) {
    this.modalService.calledfor('editar');
    this.modalService.show(FuncionarioFormComponent, 'Editar Funcionário', funcionario);
  }

  inativarFuncionario(item: any) {
    this.mostrarModalInativar = !this.mostrarModalInativar
    this.selectedItem = item
  }

  ativarFuncionario(item: any) {
    this.mostrarModalAtivar = !this.mostrarModalAtivar
    this.selectedItem = item
  }

  inativarFuncionarioPatch() {
    let req = {...this.selectedItem}
    req.isActive = false

    this.store.dispatch(funcionarioActions.editFuncionario({funcionario: req, id: req.id}))
    this.fecharDialog()
  }

  ativarFuncionarioPatch() {
    let req = {...this.selectedItem}

    req.isActive = true

    this.store.dispatch(funcionarioActions.editFuncionario({funcionario: req, id: req.id}))
    this.fecharDialog()
  }

  deletarFuncionario(index: number) {
    this.mostrarModalDeletar = !this.mostrarModalDeletar

    this.selectedItemId = index
  }

  onDelete() {
    this.store.dispatch(funcionarioActions.deleteFuncionario({id: this.selectedItemId}))

    this.fecharDialog()
  }

  public fecharDialog() {
    this.ref?.destroy()

    this.mostrarModalDeletar = false
    this.mostrarModalInativar = false
    this.mostrarModalAtivar = false
  }

  setProfessionName(iri: string) {
    return this.profissaoLista.filter((res: any) => {
      return res['@id'] == iri
    })[0]?.name
  }

  setUnitList(iriArray: string) {
    let selectedUnits: any[] = []

    this.listaUnidades$.subscribe(res => {
      if (res) {
        for (let iri of iriArray) {
          for (let item of res) {
            if (item['@id'] == iri) {
              selectedUnits.push(item.unitName)
              break;
            }
          }
        }
      }
    })

    return selectedUnits
  }

  onPageChange(event: any) {
    this.filterParams.filter("page", event.page)

    this.funcionarioService.setFilterQueryParams(this.filterParams.convertFilterInQuery());
    this.load();
  }

  onFilterChange(event: any) {
    event.forEach((e: any) => {
      this.filterParams.setFilter(e.key, e.filter);
    });

    this.filterParams.filter('page', '1')
    this.tableRef.setPage(0);

    this.funcionarioService.setFilterQueryParams(this.filterParams.convertFilterInQuery());
    this.load();
  }

  filterName(name: string) {
    this.filterParams.clearFilter('name');
    if (name.length > 0) {
      this.filterParams.filter('name', name);
    }

    this.filterParams.filter('page', '1')
    this.tableRef.setPage(0);

    this.funcionarioService.setFilterQueryParams(this.filterParams.convertFilterInQuery());
    this.load();
  }

  /* mock */

  profissaoLista: any[] = [
    {
      "@id": "/api/professions/1",
      "@type": "Profession",
      "id": 1,
      "name": "Médico",
      "professionCategory": "/api/profession_categories/1",
      "licenseCouncil": "CRM",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/2",
      "@type": "Profession",
      "id": 2,
      "name": "Dentista",
      "professionCategory": "/api/profession_categories/1",
      "licenseCouncil": "CRO",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/3",
      "@type": "Profession",
      "id": 3,
      "name": "Nutricionista",
      "professionCategory": "/api/profession_categories/1",
      "licenseCouncil": "CRN",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/4",
      "@type": "Profession",
      "id": 4,
      "name": "Enfermeiro",
      "professionCategory": "/api/profession_categories/1",
      "licenseCouncil": "COREN",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/5",
      "@type": "Profession",
      "id": 5,
      "name": "Fisioterapeuta",
      "professionCategory": "/api/profession_categories/1",
      "licenseCouncil": "CREFITO",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/6",
      "@type": "Profession",
      "id": 6,
      "name": "Terapeuta Ocupacional",
      "professionCategory": "/api/profession_categories/1",
      "licenseCouncil": "CREFITO",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/7",
      "@type": "Profession",
      "id": 7,
      "name": "Fonoaudiólogo",
      "professionCategory": "/api/profession_categories/1",
      "licenseCouncil": "CREFONO",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/8",
      "@type": "Profession",
      "id": 8,
      "name": "Veterinário",
      "professionCategory": "/api/profession_categories/1",
      "licenseCouncil": "CRMV",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/9",
      "@type": "Profession",
      "id": 9,
      "name": "Psicólogo",
      "professionCategory": "/api/profession_categories/1",
      "licenseCouncil": "CRP",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/10",
      "@type": "Profession",
      "id": 10,
      "name": "Outro profissional da saúde",
      "professionCategory": "/api/profession_categories/1",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/11",
      "@type": "Profession",
      "id": 11,
      "name": "Cabeleireiro",
      "professionCategory": "/api/profession_categories/2",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/12",
      "@type": "Profession",
      "id": 12,
      "name": "Esteticista",
      "professionCategory": "/api/profession_categories/2",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/13",
      "@type": "Profession",
      "id": 13,
      "name": "Manicure e Pedicure",
      "professionCategory": "/api/profession_categories/2",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/14",
      "@type": "Profession",
      "id": 14,
      "name": "Maquiador",
      "professionCategory": "/api/profession_categories/2",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/15",
      "@type": "Profession",
      "id": 15,
      "name": "Massoterapeuta",
      "professionCategory": "/api/profession_categories/2",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/16",
      "@type": "Profession",
      "id": 16,
      "name": "Terapeuta Holístico",
      "professionCategory": "/api/profession_categories/2",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/17",
      "@type": "Profession",
      "id": 17,
      "name": "Outro profissional de beleza e bem estar",
      "professionCategory": "/api/profession_categories/2",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/18",
      "@type": "Profession",
      "id": 18,
      "name": "Secretária",
      "professionCategory": "/api/profession_categories/3",
      "licenseCouncil": "",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/19",
      "@type": "Profession",
      "id": 19,
      "name": "Gerente",
      "professionCategory": "/api/profession_categories/3",
      "exceptionList": [],
      "employees": [
        "/api/employees/52"
      ]
    },
    {
      "@id": "/api/professions/20",
      "@type": "Profession",
      "id": 20,
      "name": "Assistente Administrativo",
      "professionCategory": "/api/profession_categories/3",
      "exceptionList": [],
      "employees": []
    },
    {
      "@id": "/api/professions/21",
      "@type": "Profession",
      "id": 21,
      "name": " Técnico Enfermagem",
      "professionCategory": "/api/profession_categories/3",
      "exceptionList": [],
      "employees": []
    }
  ]
}
